import {
  ButtonGroup,
  FormControl,
  FormErrorMessage,
  IconButton,
  Input,
  InputGroup,
  InputRightElement,
  useToast,
} from '@chakra-ui/react';
import { yupResolver } from '@hookform/resolvers/yup';
import React from 'react';
import { useForm } from 'react-hook-form';
import { FaCheck, FaTimes } from 'react-icons/fa';
import { useDispatch, useSelector } from 'react-redux';
import * as yup from 'yup';
import {
  addFolder,
  getFolders,
  updateFolder,
} from '../../stores/slices/resources/folders/foldersAction';
import { setActiveFolder } from '../../stores/slices/resources/folders/foldersSlice';

const FolderForm = ({ buttonProps, edit = null }) => {
  const { activeFolder } = useSelector(state => state.folders);

  const schema = yup
    .object({
      name: yup.string().required('Name is required'),
    })
    .required();

  const dispatch = useDispatch();
  const toast = useToast();
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors, isSubmitting },
  } = useForm({
    resolver: yupResolver(schema),
  });

  const onSave = async data => {
    let res;
    if (edit) {
      const formData = {
        folder_name: data.name,
      };
      res = await dispatch(updateFolder({ formData, id: edit.id }));
    } else {
      const formData = {
        folder_name: data.name,
        parent_folder_id: activeFolder.id,
      };
      res = await dispatch(addFolder({ formData }));
    }

    if (res.type === 'folders/addFolder/rejected') {
      toast({
        title: 'Something went wrong',
        description: 'Please try again later.',
        status: 'error',
        duration: 3000,
        isClosable: true,
        position: 'bottom-right',
      });
    } else {
      reset();
      buttonProps.onClick();
      dispatch(setActiveFolder({ ...activeFolder, name: data.name }));
      dispatch(getFolders());
      toast({
        description: 'Folder added',
        colorScheme: 'primary',
        status: 'success',
        duration: 3000,
        isClosable: true,
        position: 'bottom-right',
        variant: 'primary',
      });
    }
  };
  return (
    <form onSubmit={handleSubmit(onSave)}>
      <FormControl id="name" isInvalid={errors.name}>
        <InputGroup size="sm">
          <Input
            placeholder="Folder name"
            borderRadius={'md'}
            defaultValue={edit ? edit.name : ''}
            {...register('name')}
          />
          <InputRightElement w={'3.5rem'}>
            <ButtonGroup isAttached variant={'ghost'}>
              <IconButton
                size="xs"
                icon={<FaCheck />}
                color={'primary'}
                type="submit"
                isLoading={isSubmitting}
              />
              <IconButton
                size="xs"
                icon={<FaTimes />}
                colorScheme={'red'}
                {...buttonProps}
              />
            </ButtonGroup>
          </InputRightElement>
        </InputGroup>
        <FormErrorMessage>
          {errors.name && errors.name.message}
        </FormErrorMessage>
      </FormControl>
    </form>
  );
};

export default FolderForm;
